// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { Production } from "../../../data/talent-core/production";
import { ProductionRole } from "../../../data/talent-core/production-role";
import { ProductionResource } from "../../../data/talent-core/production-resource";
import { Engagement } from "../../../data/talent-core/engagement";
import { EnvelopeDocument } from "../base/envelope-document";

export class ProductionDocument extends EnvelopeDocument {
	public override Item: Production = new Production();
	public Roles: ProductionRole[] = [];
	public Resources: ProductionResource[] = [];
	public Engagements: Engagement[] = [];
}